import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Fragment from 'vue-fragment'
import axios from "axios";
import VueEcho from 'vue-echo-laravel';
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Fragment.Plugin)
Vue.config.productionTip = false;

const EchoInstance = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster:process.env.VUE_APP_PUSHER_APP_CLUSTER,
  authEndpoint: `${process.env.VUE_APP_PUSHER_AUTH_HOST}/broadcasting/auth`,
  forceTLS: false,
  auth: {
    headers: {
        Authorization: 'Bearer '+ Cookies.get("tokenSig"),
    },
  },
});
Vue.use(VueEcho, EchoInstance);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
